import { ISearchFormResultsProps } from './search-form-results.box.props';
import styled, { css } from "styled-components";
import {styledByDevice} from "../../../../../themes/architecture/styled-by-device";

const DefaultBox = styled.div<ISearchFormResultsProps>`
    flex: 1;
    margin-left: 2rem;
`;

const MobileBox = styled(DefaultBox)`
    position: relative;
    margin-right: 1rem;
    ${props => props.isHybridAndroid ? css`padding-bottom: 500px;` : ""}
`;

const PCBox = styled(DefaultBox)`
    position: absolute;
    width: 45rem;
    margin: 5rem 0 0 0;
    padding: 1rem 1rem 1rem 5rem;
    background: ${props => props.theme.colors.backgroundMiddleDark};
    border: 1px solid ${props => props.theme.colors.boxBorderLight};
    border-radius: 2rem;
    max-height: calc(100vh - 55px);
    overflow-y: auto;

    &::-webkit-scrollbar {
        width: 5px;
    }

    &::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.1);
    }

    &::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.5);
    }

    &::-webkit-scrollbar-thumb:hover {
        background: rgba(255, 255, 255, 0.8);
    }
`;

export const SearchFormResultsDefaultBox = styledByDevice(PCBox, MobileBox);